<template>
  <BModal
    :active.sync="show"
    :on-cancel="cancelModal"
    has-modal-card
    trap-focus
    :can-cancel="false"
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
    class="modal-main-stats"
  >
    <div
      id="report-container"
      :key="valueUpdate"
      class="modal-card modal-confirm modal-report-value"
      style="width: auto"
    >
      <section class="modal-card-body">
        <div class="modal-report">
          <Statistics :game="game" :is-inner-component="isInnerComponent" :is-modal-open="show" @close="close" />
        </div>
      </section>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'StatisticsModal',
  components: { Statistics: () => import('@/views/Statistics') },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    game: {
      type: Object,
      default: () => ({
        gameId: 0,
        seasonId: 0,
      }),
    },
  },
  data() {
    return {
      valueUpdate: 0,
      isInnerComponent: true,
    };
  },
  methods: {
    cancelModal() {
      this.$emit('onCancel');
      this.valueUpdate += 1;
    },
    close() {
      this.$emit('closemodal');
    },
  },
};
</script>
<style>
.statistics .animation-content {
  max-width: 1320px !important;
}
@media screen and (max-width: 1320px) {
  .statistics .animation-content {
    max-width: 1220px !important;
  }
}
@media screen and (max-width: 1240px) {
  .statistics .animation-content {
    max-width: 1120px !important;
  }
}
@media screen and (max-width: 1140px) {
  .statistics .animation-content {
    max-width: 100% !important;
  }
}
/*@media screen and (max-width: 1040px) {*/
/*  .statistics .animation-content {*/
/*    max-width: 100% !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 940px) {*/
/*  .statistics .animation-content {*/
/*    max-width: 820px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 840px) {*/
/*  .statistics .animation-content {*/
/*    max-width: 720px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 740px) {*/
/*  .statistics .animation-content {*/
/*    max-width: 620px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 640px) {*/
/*  .statistics .animation-content {*/
/*    max-width: 520px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 640px) {*/
/*  .statistics .animation-content {*/
/*    max-width: 100% !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 540px) {*/
/*  .statistics .animation-content {*/
/*    max-width: 420px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 440px) {*/
/*  .statistics .animation-content {*/
/*    max-width: 320px !important;*/
/*  }*/
/*}*/
/*@media screen and (max-width: 319px) {*/
/*  .statistics .animation-content {*/
/*    max-width: 280px !important;*/
/*  }*/
/*}*/
.modal-main-stats {
  z-index: 60;
}
</style>
<style lang="scss" scoped>
.modal-card-body {
  padding: 0px 5px 0px 0px !important;
}
.modal-confirm {
  padding: 15px 15px 20px 15px;
  z-index: 0;
  @media screen and (max-width: 1030px) {
    padding: 15px 10px 20px 10px !important;
  }
  @media screen and (max-width: 768px) {
    padding: 15px 5px 20px 5px;
  }
  @media screen and (max-width: 400px) {
    padding: 15px 2px 20px 2px;
  }
  border-radius: 17px;
  box-shadow: 0 17px 32px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
::-webkit-scrollbar {
  width: 5px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #888;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
